import { Injectable } from '@angular/core'

import { OperationServiceAdapter } from './../operation'
import { JsonApiProcessor  } from './../operation/operation-processors/json-api-processor'
import { LsacResult } from '../../models'
import { User } from '../../models'
import { Observable } from 'rxjs/Rx'

@Injectable()
export class LsacService extends OperationServiceAdapter<LsacResult> {

  constructor(_processor: JsonApiProcessor) {
    super(_processor, LsacResult)
  }

  public getAccount(user: User) {
    return this.callGetOperation('get_account',  { user: user })
  }

  public signUp(user: User, productOption, includes?: string[], filters?: string[]) {
    const params = this._createParams(user, productOption)
    return this.callPostOperation(
      'link_account',
      params,
      includes,
      filters
    )
  }

  public getTestResults(user: User) {
    return this.callGetOperation('get_test_results',  { user: user })
  }

  private _createParams(user: User, productOption) {
    return {
      user: {
        id: user.id
      },
      productOption: {
        name: productOption.name
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/lsac/lsac.service.ts